import { InjectionToken } from '@angular/core';

import { DuplicateRequestMonitoringOptions } from './duplicate-request-monitoring-options.interface';

export const DUPLICATE_REQUEST_MONITORING_OPTIONS = new InjectionToken<DuplicateRequestMonitoringOptions>(
	'DUPLICATE_REQUEST_MONITORING_OPTIONS',
);
